import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../state/store";

/**
 * The supported editors types.
 * Blockly: Google Blockly editor
 * Source: read-only view of the javascript source code generated by Blockly
 */
export type Editor = "Blockly" | "Source";

/**
 * Reducers for handling the state of the editor panel
 */
export const editorSlice = createSlice({
  initialState: {
    /** The active editor */
    activeEditor: "Blockly" as Editor,
  },
  name: "editor",
  reducers: {
    setActiveEditor(state, action: PayloadAction<{ editor: Editor }>) {
      state.activeEditor = action.payload.editor;

      return state;
    },
  },
});

/**
 * Retrieves the active editor type.
 *
 * @param state the root state of the application
 *
 * @returns the currently selected Editor type
 */
export const getActiveEditor = (state: RootState) => state.editor.activeEditor;
